// src/firebase.js - Dynamic Firebase Configuration
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, OAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAnalytics } from "firebase/analytics";
import { getDatabase } from "firebase/database";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// Environment-based configuration
const getFirebaseConfig = () => {
  const env = process.env.REACT_APP_FIREBASE_ENV || "prod";
  if (env === "dev") {
    return {
      apiKey: "AIzaSyDgEJu60xm2-f3y6L_CCuUxNNXFxASGgys",
      authDomain: "image-drop-aee6c.firebaseapp.com",
      projectId: "image-drop-aee6c",
      storageBucket: "image-drop-aee6c.appspot.com",
      messagingSenderId: "717299503411",
      appId: "1:717299503411:web:9d6e173dac7ce735c0ae46",
      measurementId: "G-PFNP7SX51Q",
    };
  } else {
    // Production configuration
    return {
      apiKey: "AIzaSyD_ZY2qvKPXMsBLgHlWXPb1HP-busvHocs",
      authDomain: "damia-gcp.firebaseapp.com",
      projectId: "damia-gcp",
      storageBucket: "damia-gcp.firebasestorage.app",
      messagingSenderId: "368345911172",
      appId: "1:368345911172:web:5d251db22ee5d2162197d1",
      measurementId: "G-Q0243T8RF3",
    };
  }
};

const firebaseConfig = getFirebaseConfig();
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const provider = new GoogleAuthProvider();
const microsoftProvider = new OAuthProvider("microsoft.com");
const analytics = getAnalytics(app);
const database = getDatabase(app);
const functions = getFunctions(app);

// Connect to Firebase Functions emulator in development
if (window.location.hostname === "localhost") {
  console.log("🔧 Connecting to Firebase Functions emulator at localhost:5001");
  connectFunctionsEmulator(functions, "localhost", 5001);
}

export { auth, db, storage, provider, microsoftProvider, analytics, database, functions };
